import { createAxiosClient } from "@ntg/component-library/utilities";
import { useQuery } from "@tanstack/react-query";
import { IComparisonInfo } from "../../declarations/types";
import { IReadVerbPayload } from "../../declarations/IReadVerbPayload";

const getServiceOrderHeaderComparison = async (
    payload: IReadVerbPayload,
): Promise<IComparisonInfo[]> => {
    const axiosAuth = createAxiosClient("D365FO");
    const response = await axiosAuth.post<IComparisonInfo[]>(
        `/ServiceOrder/ServiceOrderHeaderComparisonInfoD365`,
        payload,
    );
    return response.data;
};

export const useGetServiceOrderHeaderComparison = (payload: IReadVerbPayload) => {
    const dataAreaId = payload.keys.dataAreaId as string;
    const salesOrderNumber = payload.keys.salesOrderNumber as string;
    const serviceOrderID = payload.keys.serviceOrderID as number;

    return useQuery<IComparisonInfo[]>({
        queryKey: [
            "GetServiceOrderHeaderComparisonInfoD365",
            {
                serviceOrderID: serviceOrderID ?? null,
                dataAreaId: dataAreaId ?? null,
                salesOrderNumber: salesOrderNumber ?? null,
            },
        ],
        queryFn: () => {
            if (!serviceOrderID || serviceOrderID <= 0 || !dataAreaId || !salesOrderNumber) {
                throw new Error(
                    "Invalid params for GetServiceOrderHeaderComparisonInfoD365",
                );
            }
            return getServiceOrderHeaderComparison(payload);
        },
        enabled:
            Boolean(
                !serviceOrderID || serviceOrderID <= 0 || !dataAreaId || !salesOrderNumber,
            ) === false,
        refetchOnWindowFocus: false,
        retry: false,
    });
};
